var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00093 14.96V9.12866C3.00093 9.12866 3.00972 7.15546 5.00142 7.05599C6.99313 6.95652 7.97487 7.0199 7.97487 7.0199C7.97487 7.0199 9.83935 7.10595 9.96149 9.08378C10.0836 11.0616 9.96149 14.5329 9.96149 14.5329H8.50229L8.4935 22.0912L4.42913 22.0449L4.47539 14.5444L3 14.5861",
    stroke: "#D4BC87",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50893 5.97879C7.60764 5.97879 8.49832 5.08811 8.49832 3.98939C8.49832 2.89068 7.60764 2 6.50893 2C5.41021 2 4.51953 2.89068 4.51953 3.98939C4.51953 5.08811 5.41021 5.97879 6.50893 5.97879Z",
    stroke: "#D4BC87",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4894 5.99051C18.5881 5.99051 19.4788 5.09982 19.4788 4.00111C19.4788 2.9024 18.5881 2.01172 17.4894 2.01172C16.3907 2.01172 15.5 2.9024 15.5 4.00111C15.5 5.09982 16.3907 5.99051 17.4894 5.99051Z",
    stroke: "#D4BC87",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9961 16.0091L18.9822 22.0282H15.9773V16.0091H12.9766L15.2847 9.00274C15.2847 9.00274 15.566 6.93886 17.4892 6.96708C19.4125 6.99531 19.6836 9.06705 19.6836 9.06705L22.001 16.0202L18.9961 16.0091Z",
    stroke: "#D4BC87",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.acfb2dff545f94a615b8963db9a200f5.svg";
export { ForwardRef as ReactComponent };